import React, { useState, useEffect } from 'react'
import find from 'lodash/fp/find'
import flow from 'lodash/fp/flow'
import map from 'lodash/fp/map'
import filter from 'lodash/fp/filter'
import { Link } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'

import { Provider } from '../../../types'
import { getImageUrl } from '../../../common'
import { GET_PROVIDER_MAIN_IMAGES } from '../../../graphql'

import { TopSearchesContainer } from './style'

interface ICategory {
  providerPrimaryImageID: string
  name: string
  provider?: Provider
  link: string
}
const TopSearches: React.FC<{ className?: string }> = ({ className = '' }) => {
  const [categories, setCategories] = useState<ICategory[]>(() => [
    {
      providerPrimaryImageID: '36542f2c-338b-4fe0-813f-e08825b46559',
      name: 'Tulum',
      link: '/locations?where=Tulum%20beach',
    },
    {
      providerPrimaryImageID: 'eb644d4e-56f0-4616-b8c1-71945221eec3',
      name: 'Historic Estates',
      link: '/locations?where=mallorca&what=historic%20estates',
    },
    {
      providerPrimaryImageID: '46ca3ed6-e25a-47c2-ba18-e88c64d5bd74',
      name: 'Caribbean Islands',
      link: '/locations?where=caribbean&what=island',
    },
    {
      providerPrimaryImageID: '03570b87-40d4-466d-a9eb-e584922b7bde',
      name: 'Lake Como',
      link: '/locations?where=Lake%20Como',
    },
    {
      providerPrimaryImageID: 'ca6a5536-3f56-4dcf-b4e7-f0d1238484fb',
      name: 'Santorini',
      link: '/locations?where=santorini',
    },
    {
      providerPrimaryImageID: '5b0ed92e-78cf-4249-ac01-8a5c2a72f73a',
      name: 'Tuscany',
      link: '/locations?where=tuscany',
    },
    {
      providerPrimaryImageID: '2d142028-0cfc-40ca-a7ab-6a200570d371',
      name: 'Los Cabos',
      link: '/locations?where=Los%20cabos',
    },
    {
      providerPrimaryImageID: '2aff293b-2d3a-4832-a73b-644f28b48655',
      name: 'Amalfi Coast',
      link: '/locations?where=Amalfi%20Coast',
    },
    {
      providerPrimaryImageID: '228990bc-97dc-4305-8e6d-7f310e0cb356',
      name: 'Riviera Maya',
      link: '/locations?where=Riviera%20maya',
    },
    {
      providerPrimaryImageID: 'ffab71ed-d470-4966-aeb1-a1010c686bf2',
      name: 'France',
      link: '/locations?where=France',
    },
    {
      providerPrimaryImageID: 'de21c0b3-4595-49c5-a342-ba4b77c0764d',
      name: 'San Miguel de Allende',
      link: '/locations?where=San%20Miguel%20de%20Allende',
    },
    {
      providerPrimaryImageID: '2b413f10-6c3d-4246-a4a5-ebb960da440c',
      name: 'Vallarta / Nayarit',
      link: '/locations?where=Vallarta%20/%20Nayarit',
    },
  ])

  const { data } = useQuery(GET_PROVIDER_MAIN_IMAGES, {
    variables: {
      ids: categories.map(el => el.providerPrimaryImageID),
    },
  })

  useEffect(() => {
    if (!data) return
    setCategories(
      flow(
        map((el: ICategory) => ({
          ...el,
          provider: find({ id: el.providerPrimaryImageID }, data?.providers),
        })),
        filter(el => el.provider)
      )(categories)
    )

    // to prevent infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  if (!data) return <></>
  return (
    <TopSearchesContainer className={className}>
      <h2 className="fwb w-100 text-center fz-35">Top Wedding Destinations</h2>
      <span className="line bg-secondary mt-3 mb-5" />

      <div className="searches-grid">
        {categories.map(el => {
          const image = getImageUrl(el.provider?.mainImage, '400x280')
          return (
            <Link to={el.link} key={`category-${el.providerPrimaryImageID}`}>
              <div className="card-search shadow">
                <img src={image} alt={el.provider?.name} className="mw-100" />
                <span>{el.name}</span>
              </div>
            </Link>
          )
        })}
      </div>
    </TopSearchesContainer>
  )
}

export default TopSearches
